import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import { toHumanReadableStringDatetimeUtil } from 'utils/datetime'
import { getStatusLabelOrderUtil } from 'models/daos/order/utils'
import { COUNTRY_CURRENCY } from 'modules/country/constants/currency'
import { View } from 'components/View'
import {
  STYLES_FONT_SIZE,
  STYLES_MARGIN
} from 'modules/styles/constants/index.cjs'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import getPriceStringUtil from 'utils/string/get-price'

class OrderRowHeader extends React.Component {
  renderDelivery () {
    return (
      <View style={{ flex: '1' }}>
        <span><b>SHIPPING</b></span>
        <span>
          <span>{getValueReduxUtil(this.props.order, 'shippingService')}</span>
          <span> (</span>
          <FormattedNumber
            currency={this.props.currency}
            style='currency'
            value={getPriceStringUtil(this.props.shipping)}
          />
          <span>)</span>
        </span>
      </View>
    )
  }

  renderDiscount () {
    if (!this.props.discount) {
      return
    }
    return (
      <span>
        <span>(-</span>
        <FormattedNumber
          currency={this.props.currency}
          style='currency'
          value={getPriceStringUtil(this.props.discount)}
        />
        <span>)</span>
      </span>
    )
  }

  renderPlaced () {
    const createdAt = new Date(getValueReduxUtil(this.props.order, 'createdAt'))
    return (
      <View style={{ flex: '1' }}>
        <span><b>PLACED</b></span>
        <span>{toHumanReadableStringDatetimeUtil(createdAt)}</span>
      </View>
    )
  }

  renderStatus () {
    return (
      <View style={{ flex: '1' }}>
        <span><b>STATUS</b></span>
        <span>{getStatusLabelOrderUtil(this.props.order)}</span>
      </View>
    )
  }

  renderTotal () {
    return (
      <View style={{ flex: '1' }}>
        <span><b>TOTAL</b></span>
        <span>
          {this.renderTotalValue()}
          {this.renderDiscount()}
        </span>
      </View>
    )
  }

  renderTotalValue () {
    return (
      <FormattedNumber
        currency={this.props.currency}
        style='currency'
        value={getPriceStringUtil(this.props.total)}
      />
    )
  }

  render () {
    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          marginBottom: STYLES_MARGIN.BIG,
          fontSize: STYLES_FONT_SIZE.BODY_SMALL
        }}
      >
        {this.renderPlaced()}
        {this.renderTotal()}
        {this.renderStatus()}
        {this.renderDelivery()}
      </View>
    )
  }
}

OrderRowHeader.propTypes = {
  order: PropTypes.object,
  discount: PropTypes.number.isRequired,
  subTotal: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  shipping: PropTypes.number.isRequired,
  currency: PropTypes.oneOf(Object.values(COUNTRY_CURRENCY)).isRequired
}
export default OrderRowHeader
